export const environment = {
  production: false,
  apiUrl: 'https://alpgov-pre-api.agility.com',
  //apiUrl: 'https://localhost:44325',
  siteKey: "6LfqSiEbAAAAAPYjq4YwgSi6kCbvwiCM9IHdsRV-",
  secretKey: "6LfqSiEbAAAAAMdcRYS17REdUt9qF6fG6MK6uEuX"

};
